module.exports = __webpack_public_path__ + "static/media/ideate.24c8d5a8.png";